/* eslint-disable no-empty, no-redeclare, no-unused-vars */

import { $ as jquery } from 'jquery';
import { i18n } from '../core/i18n.js';
import { laydate } from './laydate.js';
import { form } from './form.js';
import { upload } from './upload.js';
import { laypage } from './laypage.js';
import { layer } from './layer.js';
import { createMediaCategoryTree } from './mediaCategoryTree.js';
import { getMediaManageLayerOptions, getMediaDialogFormOptions, createMediaFormFieldHtml, createMediaConfirmHtml, createMediaMobileBar, bindMediaMobilePanels, createMediaSelectionHelper, createMediaDialogFooter, bindMediaDialogFooter } from './mediaManageResponsive.js';

var $ = jquery;
var Fancybox = window.layui && window.layui.fancybox ? window.layui.fancybox : window.Fancybox;
	var trimText = function(value){
		return value == null ? '' : String(value).trim();
	};
	var escapeHtml = function(value){
		return String(value == null ? '' : value)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	};
	var safeClassName = function(value){
		return trimText(value).replace(/[^a-zA-Z0-9_-]/g, '');
	};
	i18n.set({
		messages: {
			'zh-CN': {
				fileManage: {
					addGroup: '添加分组',
					allFiles: '所有文件',
					dateRange: '日期范围',
					fileName: '文件名',
					search: '搜索',
					delete: '删除',
					move: '移动',
					uploadFile: '上传文件',
					selectAllPage: '本页全选',
					selectedCount: '已选 {count} 个',
					selectGroup: '选择分组',
					moveFile: '移动文件',
					confirm: '确定',
					cancel: '取消',
					moveSuccess: '移动成功',
					moveFailed: '移动失败',
					selectFileToMove: '请选择要移动的文件?',
					deleteFile: '删除文件',
					confirmDeleteFiles: '真的要删除选择的文件吗?',
					deleteSuccess: '删除成功',
					deleteFailed: '删除失败',
					selectFileToDelete: '请选择要删除的文件?',
					type: '类型',
					size: '大小',
					maxSelect: '最多只能选{max}个',
					renameFile: '修改文件名【{name}】',
					fileNameLabel: '文件名',
					renameSuccess: '修改成功',
					renameFailed: '修改失败',
					fileNameRequired: '文件名不能为空',
					newGroup: '新建分组',
					groupName: '分组名称',
					groupNameRequired: '请填写分组名称',
					deleteGroup: '删除分组',
					confirmDeleteGroup: '真的要删除该分组吗?',
					deleteGroupWithChildren: '请先删除子分组',
					selectFile: '选择文件',
					edit: '修改',
					groupCancel: '取消'
				}
			},
			'en-US': {
				fileManage: {
					addGroup: 'Add Group',
					allFiles: 'All Files',
					dateRange: 'Date Range',
					fileName: 'File Name',
					search: 'Search',
					delete: 'Delete',
					move: 'Move',
					uploadFile: 'Upload File',
					selectAllPage: 'Select all on page',
					selectedCount: 'Selected {count}',
					selectGroup: 'Select Group',
					moveFile: 'Move File',
					confirm: 'Confirm',
					cancel: 'Cancel',
					moveSuccess: 'Moved successfully',
					moveFailed: 'Move failed',
					selectFileToMove: 'Please select files to move',
					deleteFile: 'Delete File',
					confirmDeleteFiles: 'Are you sure you want to delete the selected files?',
					deleteSuccess: 'Deleted successfully',
					deleteFailed: 'Delete failed',
					selectFileToDelete: 'Please select files to delete',
					type: 'Type',
					size: 'Size',
					maxSelect: 'You can select at most {max}',
					renameFile: 'Rename File [{name}]',
					fileNameLabel: 'File Name',
					renameSuccess: 'Renamed successfully',
					renameFailed: 'Rename failed',
					fileNameRequired: 'File name cannot be empty',
					newGroup: 'New Group',
					groupName: 'Group Name',
					groupNameRequired: 'Please enter a group name',
					deleteGroup: 'Delete Group',
					confirmDeleteGroup: 'Are you sure you want to delete this group?',
					deleteGroupWithChildren: 'Please delete child groups first',
					selectFile: 'Select File',
					edit: 'Edit',
					groupCancel: 'Cancel'
				}
			}
		}
	});
	var t = function(key, fallback, params){
		return i18n.translate('fileManage.' + key, params, { default: fallback });
	};
	
	function FileManage(){
		
	}
	var fileManage = FileManage;
	
	fileManage.prototype.options={};
	fileManage.prototype.init=function(options){
		this.options=options;
		this._state = this._state || {
			data: {},
			dataMultiple: [],
			categoryId: 0,
			initCategories: null,
			categoryTree: null
		};
	}
	fileManage.prototype.render=function(){
		var state = this._state || (this._state = {
			data: {},
			dataMultiple: [],
			categoryId: 0,
			initCategories: null,
			categoryTree: null
		});
		var file_data = state.data || {};
		var file_data_multiple = Array.isArray(state.dataMultiple) ? state.dataMultiple : [];
		var category_id = state.categoryId || 0;
		var init_categorys = state.initCategories;
		var category_tree = state.categoryTree;
		var syncState = function(){
			state.data = file_data;
			state.dataMultiple = file_data_multiple;
			state.categoryId = category_id;
			state.initCategories = init_categorys;
			state.categoryTree = category_tree;
		};
		syncState();
		var load=layer.load();
		var fileUploadUrl=this.options.fileUploadUrl;
		var fileDelUrl=this.options.fileDelUrl;
		var fileMoveUrl=this.options.fileMoveUrl;
		var editFileNameUrl=this.options.editFileNameUrl;
		var fileCategory=this.options.fileCategory;
		var fileCategoryUrl=this.options.fileCategoryUrl;
		var fileCategoryUpdateUrl=this.options.fileCategoryUpdateUrl;
		var fileCategoryDelUrl=this.options.fileCategoryDelUrl;

	var multiple=this.options.multiple;
		var that;
		
		var size = this.options.size;
		var acceptMime = this.options.acceptMime;
		var headers = this.options.headers;
		var field = this.options.field;
		var exts = this.options.exts;
		var fileUploadData =this.options.fileUploadData;
		
		var fileUrl=this.options.fileUrl;
		var fileDialogOptions = getMediaDialogFormOptions();
		var file_s_time=0;
		var file_e_time=0;
		var file_total=0;
		var callback=this.options.callback;
		var fileMax=this.options.fileMax||12;
		
		var file_manage_div= this.options.elem+"_file_manage_div";
		var file_manage= this.options.elem+"_file_manage";
		var file_upload= this.options.elem+"_file_upload";
		var file_del= this.options.elem+"_file_del";
		var file_move= this.options.elem+"_file_move";
		var file_category= this.options.elem+"_file_category";
		var file_category_add=this.options.elem+"_file_category_add";
		var file_search_input=this.options.elem+"_file_search_input";
		var file_search_date=this.options.elem+"_file_search_date";
		var file_search_btn=this.options.elem+"_file_search_btn";
		var file_mobile_category_toggle=this.options.elem+"_file_mobile_category_toggle";
		var file_mobile_search_toggle=this.options.elem+"_file_mobile_search_toggle";
		var file_content=this.options.elem+"_file_content";
		var file_page=this.options.elem+"_file_page";
		var file_item=this.options.elem+"_file_item";
		var file_select_all=this.options.elem+"_file_select_all";
		var file_select_all_num=this.options.elem+"_file_select_all_num";
		var file_confirm= this.options.elem+"_file_confirm";
		var file_cancel= this.options.elem+"_file_cancel";
		var getFileItems = function(){
			return $("#"+file_content+" a");
		};
		var getFileItemData = function(item){
			item=$(item);
			return {
				id:item.attr('data-id'),
				path:item.attr('data-path'),
				ext:item.attr('data-ext'),
				size:item.attr('data-size'),
				title:item.find('span').text()
			};
		};
		var fileSelection = createMediaSelectionHelper({
			multiple: multiple,
			max: fileMax,
			selectClass: 'file-item-select',
			getItems: getFileItems,
			getSelectedItems: function(){
				return file_data_multiple;
			},
			setSelectedItems: function(items){
				file_data_multiple = items;
				syncState();
			},
			getSingleSelected: function(){
				return file_data;
			},
			setSingleSelected: function(item){
				file_data = item;
				syncState();
			},
			setSelectedCount: function(count){
				$("#"+file_select_all_num).text(count);
			},
			setSelectAllChecked: function(checked){
				$("#"+file_select_all).prop('checked', checked);
			},
			getItemData: getFileItemData,
			markSelected: function(item){
				$("#"+file_item+"_"+item.id).addClass('file-item-select');
			},
			onLimit: function(){
				layer.msg(t('maxSelect', '最多只能选{max}个', {max: fileMax}));
			}
		});
		var updateFileSelectedCount = fileSelection.updateSelectedCount;
		var syncFileSelectAll = fileSelection.syncSelectAll;
		var applyFileSelections = fileSelection.applySelections;
		var setFileItemSelected = fileSelection.setItemSelected;
		var bindFileItems = fileSelection.bindItems;
		var syncSelectedFilesFromDom = function(){
			var selectedItems = [];
			getFileItems().filter('.file-item-select').each(function(){
				selectedItems.push(getFileItemData(this));
			});
			if(multiple){
				file_data_multiple = selectedItems;
			}else{
				file_data = selectedItems.length ? selectedItems[0] : {};
			}
			syncState();
		};
		var mobilePanels = null;
		
		if($("#"+file_manage_div).length>0){

		}else{
			var html="";
			html=html+'<div id="'+file_manage_div+'" class="file-manage">';
			html=html+'<div id="'+file_manage+'" class="media-manage-shell" data-mobile-search="closed" data-mobile-category="closed">';
			html=html+createMediaMobileBar({
				categoryTriggerId: fileCategory ? file_mobile_category_toggle : '',
				searchTriggerId: file_mobile_search_toggle,
				categoryText: t('allFiles', '所有文件'),
				searchText: t('search', '搜索')
			});
			html=html+'<div class="media-manage-stage'+(fileCategory ? ' media-manage-body-with-side' : '')+'">';
			if(fileCategory){
				html=html+'<div class="media-manage-side file-manage-side">';
				html=html+'<h3 class="file-manage-category-title" id="'+file_category_add+'">'+t('addGroup', '添加分组')+'</h3>';
				html=html+'<div class="file-manage-left-content" id="'+file_category+'"></div>';
				html=html+'</div>';
				html=html+'<div class="file-manage-right media-manage-main">';
			}else{
				html=html+'<div class="file-manage-right media-manage-main">';
			}
			
			html=html+'<div class="file-manage-header">';
			html=html+'<label>'+t('dateRange', '日期范围')+'</label>';
			html=html+'<input type="text" class="layui-input layui-input-sm" id="'+file_search_date+'" >';
			html=html+'<label>'+t('fileName', '文件名')+'</label>';
			html=html+'<input type="text" class="layui-input layui-input-sm" id="'+file_search_input+'" >';
			html=html+'<button class="layui-btn layui-btn-sm" id="'+file_search_btn+'"><i class="layui-icon">&#xe615;</i>'+t('search', '搜索')+'</button>';
			html=html+'</div>';
			if(fileCategory){
				html=html+'<div class="file-content" id="'+file_content+'">';
			}else{
				html=html+'<div class="file-content file-content-no" id="'+file_content+'">';
			}
			html=html+'</div>';
			html=html+'<div class="file_page">';
			if(multiple){
			html=html+'<div class="file_page_left">';
			html=html+'<input type="checkbox" id="'+file_select_all+'"/><span>'+t('selectAllPage', '本页全选')+'</span><label>'+t('selectedCount', '已选 {count} 个', {count: '__COUNT__'}).replace('__COUNT__', '<span id="'+file_select_all_num+'">0</span>')+'</label>';
			html=html+'</div>';
			}
			html=html+'<div class="file_page_right" id="'+file_page+'"></div>';
			html=html+'</div>';
			html=html+'</div>';
			html=html+'</div>';
			var fileFooterActions='';
			fileFooterActions=fileFooterActions+'<a href="javascript:;" id="'+file_del+'" class="layui-btn layui-btn-sm layui-btn-danger media-manage-action media-manage-action-delete">'+t('delete', '删除')+'</a>';
			if(fileCategory){
				fileFooterActions=fileFooterActions+'<a href="javascript:;" id="'+file_move+'" class="layui-btn layui-btn-sm layui-btn-normal media-manage-action media-manage-action-move">'+t('move', '移动')+'</a>';
			}
			fileFooterActions=fileFooterActions+'<a href="javascript:;" id="'+file_upload+'" class="layui-btn layui-btn-sm layui-bg-green media-manage-action media-manage-action-upload">'+t('uploadFile', '上传文件')+'</a>';
			html=html+createMediaDialogFooter({
				actionsHtml: fileFooterActions,
				confirmId: file_confirm,
				cancelId: file_cancel,
				confirmText: t('confirm', '确定'),
				cancelText: t('cancel', '取消')
			});
			html=html+'</div>';
			$('body').append(html);
			
			if(multiple){
				$("#"+file_select_all).click(function(){
					var checked=$(this).prop('checked');
					getFileItems().each(function(){
						setFileItemSelected(this, checked);
					});
				});
			}
			/*时间范围选择*/
			laydate.render({
				elem: '#'+file_search_date
				,range: true
				,done: function(value, date, endDate){
					file_s_time=Date.parse(date.year+"-"+date.month+"-"+date.date+" "+date.hours+":"+date.minutes+":"+date.seconds)/1000;
					file_e_time=Date.parse(endDate.year+"-"+endDate.month+"-"+endDate.date+" "+date.hours+":"+date.minutes+":"+date.seconds)/1000+24*60*60;
				}
			});
			if(fileCategory){
				/*移动文件*/
				$("#"+file_move).click(function(){
					var html="";
					html=html+"<form class='layui-form file-layer-form' lay-filter='"+file_manage+"_filter'>"+createMediaFormFieldHtml({label:t('selectGroup', '选择分组'),fieldHtml:"<select id='"+file_manage+"_select' class='layui-select'>"});
					html=html+(category_tree ? category_tree.buildMoveOptionsHtml() : "<option value='0'>"+t('allFiles', '所有文件')+"</option>");
					html=html+"</select></div></div></form>";
					if(multiple==false){
						var arr = Object.keys(file_data); 
						if(arr.length>0){
							layer.open({
								type: 1,
								title: t('moveFile', '移动文件'),
								closeBtn: 1,
								shadeClose: false,
								skin: fileDialogOptions.skin,
								resize:false,
								scrollbar:false,
								area: fileDialogOptions.area,
								content: html,
								btn: [t('confirm', '确定'), t('cancel', '取消')],
								success: function(layero, index){
									form.render('select', file_manage+'_filter');
								},
								yes:function(index, layero){
									layer.close(index);
									var load=layer.load();
									$.ajax({
										type:'post',
										dataType:'json',
										url:fileMoveUrl,
										data:{id:file_data['id'],category_id:$("#"+file_manage+'_select').val()},
				success:function(result){
					layer.close(load);
											if(result.code==0){
												layer.msg(t('moveSuccess', '移动成功'));
												$("#"+file_item+"_"+file_data['id']).remove();
												file_data={};
											}else{
												layer.msg(t('moveFailed', '移动失败'));
											}
										}
									})
								}
							})
						}else{
							layer.msg(t('selectFileToMove', '请选择要移动的文件?'));
						}
					}else{
						if(file_data_multiple.length>0){
							layer.open({
								type: 1,
								title: t('moveFile', '移动文件'),
								closeBtn: 1,
								shadeClose: false,
								skin: fileDialogOptions.skin,
								resize:false,
								scrollbar:false,
								area: fileDialogOptions.area,
								content: html,
								btn: [t('confirm', '确定'), t('cancel', '取消')],
								success: function(layero, index){
									form.render('select', file_manage+'_filter');
								},
								yes:function(index, layero){
									layer.close(index);
									var load=layer.load();
									var ids=Array();
									for(let i in file_data_multiple){
										ids.push(file_data_multiple[i]['id']);
									}
									$.ajax({
										type:'post',
										dataType:'json',
										url:fileMoveUrl,
										data:{id:ids,category_id:$("#"+file_manage+'_select').val()},
										success:function(result){
											layer.close(load);
											if(result.code==0){
												layer.msg(t('moveSuccess', '移动成功'));
												for(let i in file_data_multiple){
													$("#"+file_item+"_"+file_data_multiple[i]['id']).remove();
												}
												file_data_multiple=Array();
												updateFileSelectedCount();
												syncFileSelectAll();
											}else{
												layer.msg(t('moveFailed', '移动失败'));
											}
										}
									})
								}
							})
						}else{
							layer.msg(t('selectFileToMove', '请选择要移动的文件?'));
						}
					}
				});
			}
			/*删除事件*/
			$("#"+file_del).click(function(){
				if(multiple==false){
					var arr = Object.keys(file_data); 
					if(arr.length>0){
						layer.open({
							type: 1,
							title: t('deleteFile', '删除文件'),
							closeBtn: 1,
							shadeClose: false,
							skin: fileDialogOptions.skin,
							resize:false,
							scrollbar:false,
							area: fileDialogOptions.area,
							content: createMediaConfirmHtml(t('confirmDeleteFiles', '真的要删除选择的文件吗?')),
							btn: [t('confirm', '确定'), t('cancel', '取消')],
							yes:function(index, layero){
								layer.close(index);
								var load=layer.load();
								$.ajax({
									type:'post',
									dataType:'json',
									url:fileDelUrl,
									data:{id:file_data['id']},
									success:function(result){
										layer.close(load);
										if(result.code==0){
											layer.msg(t('deleteSuccess', '删除成功'));
											$("#"+file_item+"_"+file_data['id']).remove();
											file_data={};
										}else{
											layer.msg(t('deleteFailed', '删除失败'));
										}
									}
								})
							}
						})
					}else{
						layer.msg(t('selectFileToDelete', '请选择要删除的文件?'));
					}
				}else{
					if(file_data_multiple.length>0){
						layer.open({
							type: 1,
							title: t('deleteFile', '删除文件'),
							closeBtn: 1,
							shadeClose: false,
							skin: fileDialogOptions.skin,
							resize:false,
							scrollbar:false,
							area: fileDialogOptions.area,
							content: createMediaConfirmHtml(t('confirmDeleteFiles', '真的要删除选择的文件吗?')),
							btn: [t('confirm', '确定'), t('cancel', '取消')],
							success: function(layero, index){
								
							},
							yes:function(index, layero){
								layer.close(index);
								var load=layer.load();
								var ids=Array();
								for(let i in file_data_multiple){
									ids.push(file_data_multiple[i]['id']);
								}
								$.ajax({
									type:'post',
									dataType:'json',
									url:fileDelUrl,
									data:{id:ids},
									success:function(result){
										layer.close(load);
										if(result.code==0){
											layer.msg(t('deleteSuccess', '删除成功'));
											for(let i in file_data_multiple){
												$("#"+file_item+"_"+file_data_multiple[i]['id']).remove();
											}
											file_data_multiple=Array();
											updateFileSelectedCount();
											syncFileSelectAll();
										}else{
											layer.msg(t('deleteFailed', '删除失败'));
										}
									}
								})
							}
						})
					}else{
						layer.msg(t('selectFileToDelete', '请选择要删除的文件?'));
					}
				}
			});
			/*搜索事件*/
			$("#"+file_search_btn).click(function(data){
				uploadFile.reload({data:{category_id:category_id}});
				var load=layer.load();
				if($("#"+file_search_date).val()==''){
					file_s_time=0;
					file_e_time=0;
				}
				$.ajax({
					type:'post',
					dataType:'json',
					url:fileUrl,
					data:{s_time:file_s_time,e_time:file_e_time,page:1,category_id:category_id,name:$("#"+file_search_input).val()},
					success:function(result){
						layer.close(load);
						$("#"+file_content).empty();
						var list = result.data;
						file_total=result.count;
						for(var i=0;i<list.length;i++){
							$("#"+file_content).append("<a data-id='"+list[i].id+"' data-path='"+escapeHtml(list[i].path)+"' data-ext='"+escapeHtml(list[i].ext)+"' data-size='"+escapeHtml(list[i].size)+"' id='"+file_item+'_'+list[i].id+"'><em class='file_type_"+safeClassName(list[i].ext)+"'></em><p>"+t('type', '类型')+":"+escapeHtml(list[i].ext)+"<br/>"+t('size', '大小')+":"+escapeHtml(list[i].size)+"</p><label class='file_item_label' data='"+list[i]['id']+"'><span>"+escapeHtml(list[i].name)+"</span><i class='layui-icon layui-icon-edit'></i></label><ins><i class='layui-icon layui-icon-ok'></i></ins></a>");
						}
						applyFileSelections();
						bindFileItems();
						/*编辑文件名*/
						$("#"+file_content+" a label i").off();
						$("#"+file_content+" a label i").click(function(event){
							event.stopPropagation();
							that=$(this).parent();
							if($(this).hasClass('layui-icon-edit')){
								var name=that.find('span').text();
								var tmp_id=that.attr('data');
								layer.open({
									type: 1,
									title: t('renameFile', '修改文件名【{name}】', {name: name}),
									closeBtn: 1,
									shadeClose: false,
									skin: 'layui-layer-g3ys-form',
									resize:false,
									scrollbar:false,
									area: ['470px', '230px'],
									content: "<div class='layui-form-item' style='padding-top:50px;padding-right:30px;'><label class='layui-form-label'>"+t('fileNameLabel', '文件名')+"</label><div class='layui-input-block'><input type='text' value='"+name+"' class='layui-input'></div></div>",
									btn: [t('confirm', '确定'), t('cancel', '取消')],
									yes:function(index, layero){
										layer.close(index);
										var tmp_val=trimText($(layero).find('input').val());
										if(tmp_val!=''){
											var load=layer.load();
											$.ajax({
												type:'post',
												dataType:'json',
												url:editFileNameUrl,
												data:{id:tmp_id,name:tmp_val},
												success:function(result){
													layer.close(load);
													if(result.code==0){
														layer.msg(t('renameSuccess', '修改成功'));
														$(".file_item_label[data='"+tmp_id+"']").find('span').text(tmp_val);
													}else{
														layer.msg(t('renameFailed', '修改失败'));
													}
												}
											})
										}else{
											layer.msg(t('fileNameRequired', '文件名不能为空'));
										}
									}
								});
							}
						});
						laypage.render({
							elem: file_page
							,count: file_total
							,limit:15
							,jump: function(obj, first){
								if(!first){
									$("#"+file_content).empty();
									$.ajax({
										type:'post',
										dataType:'json',
										url:fileUrl,
										data:{s_time:file_s_time,e_time:file_e_time,page:obj.curr,category_id:category_id},
										success:function(result){
											$("#"+file_content).empty();
											var list = result.data;
											for(var i=0;i<list.length;i++){
												$("#"+file_content).append("<a data-id='"+list[i].id+"' data-path='"+escapeHtml(list[i].path)+"' data-ext='"+escapeHtml(list[i].ext)+"' data-size='"+escapeHtml(list[i].size)+"' id='"+file_item+"_"+list[i].id+"'><em class='file_type_"+safeClassName(list[i].ext)+"'></em><p>"+t('type', '类型')+":"+escapeHtml(list[i].ext)+"<br/>"+t('size', '大小')+":"+escapeHtml(list[i].size)+"</p><label class='file_item_label' data='"+list[i]['id']+"'><span>"+escapeHtml(list[i].name)+"</span><i class='layui-icon layui-icon-edit'></i></label><ins><i class='layui-icon layui-icon-ok'></i></ins></a>");
											}
											$("#"+file_content+" a").click(function(){
												if($(this).hasClass('file-item-select')){
													$(this).removeClass('file-item-select');
													let tmp_id=$(this).attr('data-id');
													if(multiple==false){
														file_data={};
													}else{
														for(let i in file_data_multiple){
															if(file_data_multiple[i]['id']==tmp_id){
																file_data_multiple.splice(i,1);
															}
														}
														$("#"+file_select_all_num).text(file_data_multiple.length);
													}
												}else{
													if(multiple==false){
														$("#"+file_content+" a").removeClass('file-item-select');
														file_data={id:$(this).attr('data-id'),path:$(this).attr('data-path'),ext:$(this).attr('data-ext'),size:$(this).attr('data-size'),title:$(this).find('span').text()};
													}else{
														if(file_data_multiple.length>=fileMax){
															layer.msg(t('maxSelect', '最多只能选{max}个', {max: fileMax}));
															return false;
														}else{
															var tmp_file_data={id:$(this).attr('data-id'),path:$(this).attr('data-path'),ext:$(this).attr('data-ext'),size:$(this).attr('data-size'),title:$(this).find('span').text()};
															file_data_multiple.push(tmp_file_data);
															$("#"+file_select_all_num).text(file_data_multiple.length);
															$(this).addClass('file-item-select');
														}
													}
													$(this).addClass('file-item-select');
												}
											});
											/*编辑文件名*/
										$("#"+file_content+" a label i").off();
										$("#"+file_content+" a label i").click(function(event){
											event.stopPropagation();
											that=$(this).parent();
											
											if($(this).hasClass('layui-icon-edit')){
												var name=that.find('span').text();
												var tmp_id=that.attr('data');
												layer.open({
													type: 1,
													title: t('renameFile', '修改文件名【{name}】', {name: name}),
													closeBtn: 1,
													shadeClose: false,
													skin: 'layui-layer-g3ys-form',
													resize:false,
													scrollbar:false,
													area: ['470px', '230px'],
													content: "<div class='layui-form-item' style='padding-top:50px;padding-right:30px;'><label class='layui-form-label'>"+t('fileNameLabel', '文件名')+"</label><div class='layui-input-block'><input type='text' value='"+name+"' class='layui-input'></div></div>",
													btn: [t('confirm', '确定'), t('cancel', '取消')],
													yes:function(index, layero){
														layer.close(index);
														var tmp_val=trimText($(layero).find('input').val());
														if(tmp_val!=''){
															var load=layer.load();
															$.ajax({
																type:'post',
																dataType:'json',
																url:editFileNameUrl,
																data:{id:tmp_id,name:tmp_val},
																success:function(result){
																	layer.close(load);
																	if(result.code==0){
																		layer.msg(t('renameSuccess', '修改成功'));
																		$(".file_item_label[data='"+tmp_id+"']").find('span').text(tmp_val);
																	}else{
																		layer.msg(t('renameFailed', '修改失败'));
																	}
																}
															})
														}else{
															layer.msg(t('fileNameRequired', '文件名不能为空'));
														}
													}
												});
											}
										});
										}
									})
								}
							}
						});
					}
				});
				mobilePanels && mobilePanels.closeSearch();
				return false;
			});
		
		/*初始上传按钮*/
		var uploadFile=upload.render({
			elem: '#'+file_upload
			,url: fileUploadUrl
			,field:field||'file'
			,acceptMime:acceptMime||'image/png,image/gif,image/jpeg,image/webp,image/bmp,application/zip,application/x-rar-compressed,application/x-tar,application/x-gzip,application/msword,text/plain,text/xml,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation'
			,size:size||50*1024*1024
			,headers:headers||''
			,exts:exts||'jpg|gif|png|jpeg|pneg|webp|bmp|zip|rar|tar|gz|doc|docx|txt|xml|xlsx|ppt|pptx'
			,data:fileUploadData||''
			,multiple:multiple
			,before:function(obj){
				layer.load();
			}
			,done: function(result){
				layer.closeAll('loading'); 
				if(result.code=='0'){
					$("#"+file_content).prepend("<a data-id='"+result.data.id+"' data-path='"+escapeHtml(result.data.path)+"' data-ext='"+escapeHtml(result.data.ext)+"' data-size='"+escapeHtml(result.data.size)+"'  id='"+file_item+'_'+result.data.id+"'><em class='file_type_"+safeClassName(result.data.ext)+"'></em><p>"+t('type', '类型')+":"+escapeHtml(result.data.ext)+"<br/>"+t('size', '大小')+":"+escapeHtml(result.data.size)+"</p><label class='file_item_label' data='"+result.data.id+"'><span>"+escapeHtml(result.data.name)+"</span><i class='layui-icon layui-icon-edit'></i></label><ins><i class='layui-icon layui-icon-ok'></i></ins></a>");
					applyFileSelections();
					bindFileItems();
					/*编辑文件名*/
					$("#"+file_content+" a label i").off();
					$("#"+file_content+" a label i").click(function(event){
						event.stopPropagation();
						that=$(this).parent();
						if($(this).hasClass('layui-icon-edit')){
							var name=that.find('span').text();
							var tmp_id=that.attr('data');
							layer.open({
								type: 1,
								title: t('renameFile', '修改文件名【{name}】', {name: name}),
								closeBtn: 1,
								shadeClose: false,
								skin: 'layui-layer-g3ys-form',
								resize:false,
								scrollbar:false,
								area: ['470px', '230px'],
								content: "<div class='layui-form-item' style='padding-top:50px;padding-right:30px;'><label class='layui-form-label'>"+t('fileNameLabel', '文件名')+"</label><div class='layui-input-block'><input type='text' value='"+name+"' class='layui-input'></div></div>",
								btn: [t('confirm', '确定'), t('cancel', '取消')],
								yes:function(index, layero){
									layer.close(index);
									var tmp_val=trimText($(layero).find('input').val());
									if(tmp_val!=''){
										var load=layer.load();
										$.ajax({
											type:'post',
											dataType:'json',
											url:editFileNameUrl,
											data:{id:tmp_id,name:tmp_val},
											success:function(result){
												layer.close(load);
												if(result.code==0){
													layer.msg(t('renameSuccess', '修改成功'));
													$(".file_item_label[data='"+tmp_id+"']").find('span').text(tmp_val);
												}else{
													layer.msg(t('renameFailed', '修改失败'));
												}
											}
										})
									}else{
										layer.msg(t('fileNameRequired', '文件名不能为空'));
									}
								}
							});
						}
					});
					setFileItemSelected($("#"+file_item+"_"+result.data.id), true);
				}else{
					layer.msg(result.msg);
				}
			}
		});
		if(fileCategory){
			/*添加分类*/
			$("#"+file_category_add).off();
			category_tree = createMediaCategoryTree({
				elem: "#"+file_category,
				addButton: "#"+file_category_add,
				categoryUrl: fileCategoryUrl,
				updateUrl: fileCategoryUpdateUrl,
				deleteUrl: fileCategoryDelUrl,
				allLabel: t('allFiles', '所有文件'),
				getSelectedId: function(){
					return category_id;
				},
				setSelectedId: function(value){
					category_id = value;
					syncState();
				},
				onSelect: function(){
					$("#"+file_search_btn).click();
					mobilePanels && mobilePanels.closeCategory();
				},
				texts: {
					addGroup: t('addGroup', '添加分组'),
					newGroup: t('newGroup', '新建分组'),
					groupName: t('groupName', '分组名称'),
					groupNameRequired: t('groupNameRequired', '请填写分组名称'),
					confirm: t('confirm', '确定'),
					cancel: t('cancel', '取消'),
					edit: t('edit', '修改'),
					delete: t('delete', '删除'),
					deleteGroup: t('deleteGroup', '删除分组'),
					confirmDeleteGroup: t('confirmDeleteGroup', '真的要删除该分组吗?'),
					deleteGroupWithChildren: t('deleteGroupWithChildren', '请先删除子分组'),
					renameSuccess: t('renameSuccess', '修改成功'),
					renameFailed: t('renameFailed', '修改失败'),
					deleteSuccess: t('deleteSuccess', '删除成功'),
					deleteFailed: t('deleteFailed', '删除失败')
				}
			});
			init_categorys = category_tree.reload;
			syncState();
			init_categorys();
		}
		/*获取文件*/
		$.ajax({
				type:'post',
				dataType:'json',
				url:fileUrl,
				data:{s_time:file_s_time,e_time:file_e_time,page:1,category_id:category_id},
				success:function(result){
					$("#"+file_content).empty();
					var list = result.data;
					file_total=result.count;
					if(list){
						for(var i=0;i<list.length;i++){
							$("#"+file_content).append("<a data-id='"+list[i].id+"' data-path='"+escapeHtml(list[i].path)+"' data-ext='"+escapeHtml(list[i].ext)+"' data-size='"+escapeHtml(list[i].size)+"' id='"+file_item+"_"+list[i].id+"'><em class='file_type_"+safeClassName(list[i].ext)+"'></em><p>"+t('type', '类型')+":"+escapeHtml(list[i].ext)+"<br/>"+t('size', '大小')+":"+escapeHtml(list[i].size)+"</p><label class='file_item_label' data='"+list[i]['id']+"'><span>"+escapeHtml(list[i].name)+"</span><i class='layui-icon layui-icon-edit'></i></label><ins><i class='layui-icon layui-icon-ok'></i></ins></a>");
						}
					}
					applyFileSelections();
					bindFileItems();
					/*编辑文件名*/
					$("#"+file_content+" a label i").click(function(event){
						event.stopPropagation();
						that=$(this).parent();
						
						if($(this).hasClass('layui-icon-edit')){
							var name=that.find('span').text();
							var tmp_id=that.attr('data');
							layer.open({
								type: 1,
								title: t('renameFile', '修改文件名【{name}】', {name: name}),
								closeBtn: 1,
								shadeClose: false,
								skin: 'layui-layer-g3ys-form',
								resize:false,
								scrollbar:false,
								area: ['470px', '230px'],
								content: "<div class='layui-form-item' style='padding-top:50px;padding-right:30px;'><label class='layui-form-label'>"+t('fileNameLabel', '文件名')+"</label><div class='layui-input-block'><input type='text' value='"+name+"' class='layui-input'></div></div>",
								btn: [t('confirm', '确定'), t('cancel', '取消')],
								yes:function(index, layero){
									layer.close(index);
									var tmp_val=trimText($(layero).find('input').val());
									if(tmp_val!=''){
										var load=layer.load();
										$.ajax({
											type:'post',
											dataType:'json',
											url:editFileNameUrl,
											data:{id:tmp_id,name:tmp_val},
											success:function(result){
												layer.close(load);
												if(result.code==0){
													layer.msg(t('renameSuccess', '修改成功'));
													$(".file_item_label[data='"+tmp_id+"']").find('span').text(tmp_val);
												}else{
													layer.msg(t('renameFailed', '修改失败'));
												}
											}
										})
									}else{
										layer.msg(t('fileNameRequired', '文件名不能为空'));
									}
								}
							});
						}
					});

					laypage.render({
						elem: file_page
						,count: file_total
						,limit:15
						,jump: function(obj, first){

							if(!first){
								$.ajax({
									type:'post',
									dataType:'json',
									url:fileUrl,
									data:{s_time:file_s_time,e_time:file_e_time,page:obj.curr,category_id:category_id},
									success:function(result){
										$("#"+file_content).empty();
										var list = result.data;
										for(var i=0;i<list.length;i++){
											$("#"+file_content).append("<a data-id='"+list[i].id+"' data-path='"+escapeHtml(list[i].path)+"' data-ext='"+escapeHtml(list[i].ext)+"' data-size='"+escapeHtml(list[i].size)+"' id='"+file_item+"_"+list[i].id+"'><em class='file_type_"+safeClassName(list[i].ext)+"'></em><p>"+t('type', '类型')+":"+escapeHtml(list[i].ext)+"<br/>"+t('size', '大小')+":"+escapeHtml(list[i].size)+"</p><span>"+escapeHtml(list[i].name)+"</span><ins><i class='layui-icon layui-icon-ok'></i></ins></a>");
										}
										applyFileSelections();
										bindFileItems();

										/*编辑文件名*/
										$("#"+file_content+" a label i").off();
										$("#"+file_content+" a label i").click(function(event){
											event.stopPropagation();
											that=$(this).parent();
											
											if($(this).hasClass('layui-icon-edit')){
												var name=that.find('span').text();
												var tmp_id=that.attr('data');
												layer.open({
													type: 1,
													title: t('renameFile', '修改文件名【{name}】', {name: name}),
													closeBtn: 1,
													shadeClose: false,
													skin: 'layui-layer-g3ys-form',
													resize:false,
													scrollbar:false,
													area: ['470px', '230px'],
													content: "<div class='layui-form-item' style='padding-top:50px;padding-right:30px;'><label class='layui-form-label'>"+t('fileNameLabel', '文件名')+"</label><div class='layui-input-block'><input type='text' value='"+name+"' class='layui-input'></div></div>",
													btn: [t('confirm', '确定'), t('cancel', '取消')],
													yes:function(index, layero){
														layer.close(index);
														var tmp_val=trimText($(layero).find('input').val());
														if(tmp_val!=''){
															var load=layer.load();
															$.ajax({
																type:'post',
																dataType:'json',
																url:editFileNameUrl,
																data:{id:tmp_id,name:tmp_val},
																success:function(result){
																	layer.close(load);
																	if(result.code==0){
																		layer.msg(t('renameSuccess', '修改成功'));
																		$(".file_item_label[data='"+tmp_id+"']").find('span').text(tmp_val);
																	}else{
																		layer.msg(t('renameFailed', '修改失败'));
																	}
																}
															})
														}else{
															layer.msg(t('fileNameRequired', '文件名不能为空'));
														}
													}
												});
											}
										});
									}
								})
							}
						}
					});
				}
			});
			
		}
		
		
		var layerOptions = getMediaManageLayerOptions();
		this.options.layer=layer.open({
			  type: 1,
			  title: t('selectFile', '选择文件'),
			  closeBtn: 1,
			  shadeClose: false,
			  skin: 'layui-layer-g3ys-form-big media-manage-layer',
			  resize:false,
			  scrollbar:false,
			  area: layerOptions.area,
			  offset: layerOptions.offset,
			  content: $('#'+file_manage_div),
			  success: function(layero, index){
					mobilePanels = bindMediaMobilePanels({
						shellId: file_manage,
						categoryTriggerId: fileCategory ? file_mobile_category_toggle : '',
						searchTriggerId: file_mobile_search_toggle
					});
					bindMediaDialogFooter({
						confirmId: file_confirm,
						cancelId: file_cancel,
						onConfirm: function(){
							syncSelectedFilesFromDom();
							layer.close(index);
							if(multiple){
								if(file_data_multiple.length>0){
									for(let i in file_data_multiple){
										let item=file_data_multiple[i];
										var arr = Object.keys(item);
										(callback && typeof(callback)==="function"&&arr.length>0) && callback('select',item['id'],item);
									}
									file_data_multiple=Array();
									$("#"+file_select_all).prop('checked',false);
									$("#"+file_content+" a").removeClass("file-item-select");
									updateFileSelectedCount();
								}
							}else{
								var arr = Object.keys(file_data); 
								(callback && typeof(callback)==="function"&&arr.length>0) && callback('select',file_data['id'],file_data);
								file_data={};
								$("#"+file_content+" a").removeClass("file-item-select");
							}
							$("#"+file_manage_div).hide();
						},
						onCancel: function(){
							layer.close(index);
						}
					});
					$("#"+file_manage_div).show();
					layer.close(load);
			  },
			  end:function(){
					$("#"+file_manage_div).hide();
			  }
		});
	}
	fileManage.prototype.close=function(){
		layer.close(this.options.layer);
	}
export { FileManage as fileManage };
